import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/pages/Upload.js";
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import Dropzone from 'react-dropzone';
import queryString from "query-string";
import { Grid, GridListTile, Typography, MenuItem, Select, TextField, Paper, Button, Fab, ExpansionPanel, GridList, LinearProgress, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { Dialog, EntityInfo, HomeButton } from '../common';
import Util, { getSelectedPartner } from '../../util/Util';
import TpicPage from './TpicPage';
import { BASE_URIS, ID_SPACE, Q_STRING, HEADER_NAMES, SESSION_STORAGE_ITEM_NAMES } from "../domain/constants";
import { retrieveFromQueryString } from "../../util/QueryStringUtil";
import { isNotABlankString } from "../../util/StringUtil";
import { lookupForType } from "../../util/APIUtil";
const styles = theme => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    marginTop: '2vh',
    maxWidth: '80vw',
    minWidth: '80vw'
  },
  dropzone: {
    width: '100%',
    minWidth: '80vw',
    minHeight: '60vh',
    backgroundColor: '#eee'
  },
  uploadImg: {
    width: '100%',
    height: 'auto'
  },
  imgDelBtn: {
    position: 'absolute',
    top: '5px',
    right: '5px'
  },
  imageGrid: {
    padding: 8 * 3,
    margin: 10,
    display: 'flex',
    justifyContent: 'center'
  }
});
const nameSpaces = {
  adi: "ADI",
  guid: "MediaGUID",
  merlin: "MerlinID"
};
class Upload extends TpicPage {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", name => event => {
      this.setState({
        [name]: event.target.value
      });
    });
    _defineProperty(this, "handleImageDetailsChange", (name, index) => event => {
      if (this.state.duplicateAll === false) {
        if (index === -1) {
          console.error("index of -1 not valid with duplicateAll=false");
          Util.createDialog("Experienced an unexpected error", "Please use the \"Contact Support\" option in the menu", this.dialog);
          return;
        }
        const imageDetails = this.state.imageDetails;
        if (imageDetails != null && imageDetails.length > index) {
          let detail = imageDetails[index];
          detail[name] = event.target.value;
          this.forceUpdate();
        } else {
          console.warn("Image details was null, or its length was less than the index value provided");
        }
      } else if (this.state.duplicateAll === true) {
        if (index === -1) {
          this.state[name] = event.target.value;
          this.forceUpdate();
        } else console.error("index of ".concat(index, " is not valid with duplicateAll=true"));
      }
    });
    _defineProperty(this, "handleCheckChange", event => {
      this.state.duplicateAll = event.target.checked;
      this.forceUpdate();
    });
    const querystringValues = queryString.parse(this.props.location.search);
    this.state = {
      images: [],
      // never set this to null
      imageDetails: [],
      // never set this to null
      imageTypes: [],
      // never set this to null
      entityId: props.entityId != null ? props.entityId : retrieveFromQueryString(Q_STRING.MERLIN_ID, querystringValues),
      entityTitle: props.entityTitle != null ? props.entityTitle : retrieveFromQueryString(Q_STRING.TITLE, querystringValues),
      adiId: props.adiId != null ? props.adiId : retrieveFromQueryString(Q_STRING.ADI_ID, querystringValues),
      nameSpace: nameSpaces.adi,
      subtitle: null,
      inputId: '',
      uploadSuccess: false,
      loading: false,
      message: '',
      duplicateAll: false,
      photographer: null,
      distributor: null,
      imageType: '',
      type: null
    };
    this.loadImageTypes();
    if (this.state.entityId != null || this.state.adiId != null) {
      lookupForType(this, this.state.entityId, this.state.adiId);
    }
    this.dialog = null;
    this.setDialogRef = element => {
      this.dialog = element;
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.search !== this.props.location.search) {
      const querystringValues = queryString.parse(this.props.location.search);
      let entityId = retrieveFromQueryString(Q_STRING.MERLIN_ID, querystringValues);
      let adiId = retrieveFromQueryString(Q_STRING.ADI_ID, querystringValues);
      let title = retrieveFromQueryString(Q_STRING.TITLE, querystringValues);
      this.setState({
        entityId: entityId,
        entityTitle: title,
        adiId: adiId,
        inputId: '',
        images: [],
        imageDetails: [],
        uploadSuccess: false,
        duplicateAll: false,
        photographer: null,
        distributor: null,
        subtitle: null,
        imageType: ''
      });
      lookupForType(this, entityId, adiId);
    }
  }
  onDrop(acceptedFiles, rejectedFiles) {
    let images = this.state.images; // Can't call 'this' inside an anonymous function, so we need to get the reference to images here
    let imageDetails = this.state.imageDetails;

    // Add to all images
    acceptedFiles.forEach(function (file) {
      images.push(file);
      imageDetails.push({
        filename: file.name,
        imageType: ''
      });
    });
    if (rejectedFiles != null && rejectedFiles.length > 0) {
      this.displayRejectedFileDialog(rejectedFiles);
    }

    // Force React to update
    this.forceUpdate();
  }
  displayRejectedFileDialog(rejectedFiles) {
    let filenameList = /*#__PURE__*/React.createElement("ul", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 182,
        columnNumber: 28
      }
    }, rejectedFiles.map(file => /*#__PURE__*/React.createElement("li", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 184,
        columnNumber: 17
      }
    }, file.name)));
    Util.createDialog("Rejected File(s)", filenameList, this.dialog);
  }
  submitImages() {
    if (this.state.inputId == null || this.state.inputId === '') {
      if (this.state.adiId != null && this.state.adiId !== '') {
        this.setEntityFields(ID_SPACE.ADI, this.state.adiId);
      } else if (this.state.entityId != null && this.state.entityId !== '') {
        this.setEntityFields(ID_SPACE.MERLIN, this.state.entityId);
      } else {
        Util.createDialog("Missing Required Field", "You must input an ID", this.dialog);
        return;
      }
    }
    if (this.state.images.length === 0) {
      Util.createDialog("Upload Failure!", "No acceptable images were selected for upload", this.dialog);
      return;
    }
    this.state.loading = true;
    this.forceUpdate();
    this.doUpload();
  }
  doUpload() {
    const imagesForm = new FormData();
    const images = this.state.images;
    const csrfToken = sessionStorage.getItem(SESSION_STORAGE_ITEM_NAMES.CSRFTOKEN);
    images.forEach(image => {
      imagesForm.append('images', image, image.name);
    });
    imagesForm.append(Q_STRING.PROVIDER, this.state.nameSpace);
    imagesForm.append(Q_STRING.ENTITY_ID, this.state.inputId);
    imagesForm.append(SESSION_STORAGE_ITEM_NAMES.CSRFTOKEN, csrfToken);
    let success = this.appendImageDetails(imagesForm);
    if (success === false) {
      this.setState({
        uploadSuccess: false,
        loading: false
      });
      return;
    }
    const url = "".concat(BASE_URIS.prefix).concat(BASE_URIS.uploadImages);
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'x-meta-tpic-partner': getSelectedPartner()
      },
      body: imagesForm
    }).then(resp => {
      if (resp !== null) {
        if (resp.status === 401) {
          Util.loginRedirect(this.props);
          return;
        } else if (resp.ok === false) {
          let message = "The server could not handle the upload request.";
          if (resp.status === 403) {
            if (isNotABlankString(resp.message)) message = resp.message;else message = "You are not permitted to upload at this time.";
          }
          if (resp.status === 400) message = "One of the submitted images did not adhere to image upload standards.";
          this.state.uploadSuccess = false;
          this.state.message = message;
        } else {
          this.state.uploadSuccess = true;
        }
        this.state.loading = false;
        this.forceUpdate();
      }
      return resp.json();
    }).then(resp => {
      this.uploadResult(resp);
    }).catch(error => {
      let message;
      if (error instanceof SyntaxError) {
        message = "TPIC could not interpret the response it received from the server. ";
      } else {
        message = "The service encountered an error while attempting to upload your images. ";
      }
      Util.log('Upload.doUpload', true, "".concat(error, " - ").concat(error.stack), false);
      Util.createDialog("Error During Upload", message + "Please try again later, or select the 'Contact Support' option in the menu", this.dialog);
    });
  }

  /**
   * TPIS expects these params as "imageDetails[?].fieldName" instead of an array of imageDetails objects
   */
  appendImageDetails(imagesForm) {
    const _this$state = this.state,
      imageDetails = _this$state.imageDetails,
      duplicateAll = _this$state.duplicateAll;
    if (duplicateAll != null && duplicateAll === true) {
      // Use the same metadata for every image
      const _this$state2 = this.state,
        photographer = _this$state2.photographer,
        distributor = _this$state2.distributor,
        imageType = _this$state2.imageType,
        images = _this$state2.images;
      if (imageType == null || imageType === '') {
        Util.createDialog('Upload Failure: Missing Field', 'imageType is a required field', this.dialog);
        return false;
      }
      for (let index = 0; index < images.length; index++) {
        let keyPrefix = "imageDetails[".concat(index, "].");
        imagesForm.append(keyPrefix + 'imageType', imageType);
        if (this.state.photographer != null && this.state.photographer !== '') {
          imagesForm.append(keyPrefix + 'photographer', photographer);
        }
        if (this.state.distributor != null && this.state.distributor !== '') {
          imagesForm.append(keyPrefix + 'distributor', distributor);
        }
      }
      return true;
    } else {
      // user has entered individual values for each image's metadata fields
      let imageDetail, keyPrefix, imageType, photographer, distributor;
      for (let index = 0; index < imageDetails.length; index++) {
        imageDetail = imageDetails[index];
        keyPrefix = "imageDetails[".concat(index, "].");

        // imageType is required for every image
        imageType = imageDetail['imageType'];
        if (imageType != null && imageType !== '') {
          imagesForm.append(keyPrefix + 'imageType', imageType);
        } else {
          Util.createDialog('Upload Failure: Missing Field', 'imageType is a required field', this.dialog);
          return false;
        }

        // photographer and distributor are not required fields
        photographer = imageDetail['photographer'];
        if (photographer != null) {
          imagesForm.append(keyPrefix + 'photographer', photographer);
        }
        distributor = imageDetail['distributor'];
        if (distributor != null) {
          imagesForm.append(keyPrefix + 'distributor', distributor);
        }
      }
      return true;
    }
  }
  removeImageAtIndex(index) {
    const _this$state3 = this.state,
      images = _this$state3.images,
      imageDetails = _this$state3.imageDetails;
    images.splice(index, 1);
    imageDetails.splice(index, 1);
    if (images.length === 0) {
      this.setState({
        images: images,
        imageDetails: imageDetails,
        duplicateAll: false,
        photographer: null,
        distributor: null,
        imageType: ''
      });
    } else {
      this.setState({
        images: images,
        imageDetails: imageDetails
      });
    }
  }
  uploadResult(resp) {
    if (this.state.uploadSuccess) {
      Util.createDialog("Success!", this.state.images.length + " image" + (this.state.images.length === 1 ? "" : "s") + " uploaded!", this.dialog);

      // Reset page
      this.state.images = [];
      this.state.imageDetails = [];
      this.state.uploadSuccess = false;
      this.state.inputId = '';
      this.state.duplicateAll = false;
      this.state.photographer = null;
      this.state.distributor = null;
      this.state.imageType = '';
      this.forceUpdate();
    } else {
      let message = resp.message;
      if (message != null && message !== '') this.state.message = "".concat(this.state.message, "\nMessage from server: ").concat(message);
      Util.createDialog("Upload failure", this.state.message, this.dialog);
      this.state.loading = false;
      this.forceUpdate();
    }
  }
  loadImageTypes() {
    Util.fetchWithRedirect("".concat(BASE_URIS.prefix).concat(BASE_URIS.imageTypes), 'GET', this.props).then(resp => {
      resp.content.map(imageType => this.state.imageTypes.push(imageType));
      this.state.imageTypes.sort();
    }).catch(e => Util.log('Upload.loadImageTypes', true, e, false));
  }
  render() {
    const classes = this.props.classes;
    const _this$state4 = this.state,
      duplicateAll = _this$state4.duplicateAll,
      imageType = _this$state4.imageType;
    const key = this.state.merlinId != null ? this.state.merlinId : (this.state.adiId != null ? this.state.adiId : 'blank-upload-page') + '-' + this.state.loading + "-" + this.state.type;
    return /*#__PURE__*/React.createElement("div", {
      id: "grid-container",
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 402,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      alignContent: "center",
      direction: "column",
      spacing: 4,
      justify: "space-around",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 403,
        columnNumber: 17
      }
    }, this.state.adiId || this.state.entityId || this.state.entityTitle ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 406,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(EntityInfo, {
      key: key,
      onClick: () => console.log(''),
      merlinId: this.state.entityId,
      title: this.state.entityTitle,
      subtitle: this.state.subtitle,
      adiId: this.state.adiId,
      type: this.state.type,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 407,
        columnNumber: 29
      }
    })) : /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      spacing: 4,
      alignItems: "center",
      alignContent: "center",
      justify: "space-around",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 416,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 418,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Select, {
      value: this.state.nameSpace,
      onChange: this.handleChange('nameSpace'),
      displayEmpty: true,
      variant: "outlined",
      label: "ID Namespace",
      style: {
        minWidth: '80%'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 419,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: ID_SPACE.ADI,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 422,
        columnNumber: 37
      }
    }, nameSpaces.adi), /*#__PURE__*/React.createElement(MenuItem, {
      value: "mediaGuid",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 423,
        columnNumber: 37
      }
    }, nameSpaces.guid), /*#__PURE__*/React.createElement(MenuItem, {
      value: ID_SPACE.MERLIN,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 424,
        columnNumber: 37
      }
    }, nameSpaces.merlin))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 10,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 427,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      value: this.state.inputId,
      onChange: this.handleChange('inputId'),
      styles: classes.inputStyle,
      fullWidth: true,
      variant: "outlined",
      label: "ID",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 428,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "column",
      alignContent: "center",
      justify: "center",
      spacing: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 434,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 435,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 436,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 437,
        columnNumber: 33
      }
    }), this.state.loading === false && [/*#__PURE__*/React.createElement(Dropzone, {
      color: "secondary",
      className: classes.dropzone,
      accept: "image/jpg,image/jpeg,image/png",
      onDrop: (acceptedFiles, rejectedFiles) => this.onDrop(acceptedFiles, rejectedFiles),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 440,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(GridList, {
      cellHeight: "auto",
      spacing: 4,
      className: classes.imageGrid,
      style: {
        maxHeight: '65vh',
        overflow: 'auto'
      },
      cols: 4,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 444,
        columnNumber: 41
      }
    }, (this.state.images == null || this.state.images.length === 0) && /*#__PURE__*/React.createElement(Typography, {
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 447,
        columnNumber: 45
      }
    }, "Drag and drop files or click here to select images"), this.state.images != null && this.state.images.length !== 0 && this.state.images.map((item, index) => /*#__PURE__*/React.createElement(GridListTile, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 452,
        columnNumber: 49
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: classes.uploadImg,
      alt: "image-preview-".concat(index),
      src: URL.createObjectURL(item),
      onClick: e => e.preventDefault(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 453,
        columnNumber: 53
      }
    }), /*#__PURE__*/React.createElement(Fab, {
      className: classes.imgDelBtn,
      size: "small",
      onClick: e => {
        e.preventDefault(); // prevents dropzone.onClick from being called
        this.removeImageAtIndex(index);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 456,
        columnNumber: 53
      }
    }, /*#__PURE__*/React.createElement(Close, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 460,
        columnNumber: 61
      }
    })))))), /*#__PURE__*/React.createElement(ExpansionPanel, {
      defaultExpanded: true,
      elevation: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 466,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      alignContent: "center",
      justify: "space-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 467,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 469,
        columnNumber: 45
      }
    }, /*#__PURE__*/React.createElement(HomeButton, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 470,
        columnNumber: 49
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 472,
        columnNumber: 45
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: () => this.submitImages(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 473,
        columnNumber: 49
      }
    }, "Submit"))))], this.state.loading === true && /*#__PURE__*/React.createElement("div", {
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 480,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'column',
      justify: 'center',
      alignItems: 'center',
      alignContent: 'center',
      style: {
        minWidth: '50vw'
      },
      spacing: 4,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 481,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 483,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 484,
        columnNumber: 45
      }
    }, "Uploading ", this.state.images.length, " image", this.state.images.length === 1 ? '' : 's', "...")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        minWidth: '50vw'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 486,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(LinearProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 487,
        columnNumber: 45
      }
    }))))))), this.state.loading === false && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'column',
      alignContent: 'center',
      justify: 'center',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 497,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 498,
        columnNumber: 25
      }
    }, this.state.images != null && this.state.images.length > 0 && /*#__PURE__*/React.createElement(FormGroup, {
      row: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 500,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: duplicateAll,
        onChange: this.handleCheckChange,
        value: duplicateAll,
        color: 'primary',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 503,
          columnNumber: 41
        }
      }),
      label: 'Use Same Metadata For Each Image',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 501,
        columnNumber: 33
      }
    }))), duplicateAll === false && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'column',
      alignContent: 'center',
      justify: 'center',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 515,
        columnNumber: 25
      }
    }, this.state.imageDetails != null && this.state.imageDetails.length !== 0 && this.state.imageDetails.map((item, index) => /*#__PURE__*/React.createElement(Grid, {
      container: true,
      item: true,
      key: index,
      alignContent: 'center',
      justify: 'space-evenly',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 519,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      md: 1,
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 520,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: 'outlined',
      size: 'small',
      onClick: () => this.removeImageAtIndex(index),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 521,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(Close, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 522,
        columnNumber: 96
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      alignItems: 'center',
      md: 3,
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 524,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        overflow: 'auto'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 526,
        columnNumber: 41
      }
    }, item.filename)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      alignItems: 'center',
      md: 3,
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 529,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: this.handleImageDetailsChange('photographer', index),
      styles: classes.inputStyle,
      variant: "outlined",
      label: 'Photographer',
      placeholder: '(optional)',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 531,
        columnNumber: 41
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      alignItems: 'center',
      md: 3,
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 536,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: this.handleImageDetailsChange('distributor', index),
      styles: classes.inputStyle,
      variant: "outlined",
      label: 'Distributor',
      placeholder: '(optional)',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 538,
        columnNumber: 41
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      alignItems: 'center',
      md: 2,
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 543,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Select, {
      value: item['imageType'],
      onChange: this.handleImageDetailsChange('imageType', index),
      displayEmpty: true,
      variant: "outlined",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 545,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: '',
      disabled: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 549,
        columnNumber: 45
      }
    }, "Image Type"), this.state.imageTypes.map(imageType => /*#__PURE__*/React.createElement(MenuItem, {
      value: imageType,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 551,
        columnNumber: 49
      }
    }, imageType))))))), duplicateAll === true && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      item: true,
      key: duplicateAll,
      alignContent: 'center',
      justify: 'space-evenly',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 561,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      alignItems: 'center',
      md: 3,
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 562,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: this.handleImageDetailsChange('photographer', -1),
      styles: classes.inputStyle,
      variant: "outlined",
      label: 'Photographer',
      placeholder: '(optional)',
      value: this.state.photographer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 564,
        columnNumber: 33
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      alignItems: 'center',
      md: 3,
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 569,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: this.handleImageDetailsChange('distributor', -1),
      styles: classes.inputStyle,
      variant: "outlined",
      label: 'Distributor',
      placeholder: '(optional)',
      value: this.state.distributor,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 571,
        columnNumber: 33
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      alignItems: 'center',
      md: 2,
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 576,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Select, {
      value: imageType,
      onChange: this.handleImageDetailsChange('imageType', -1),
      displayEmpty: true,
      variant: "outlined",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 578,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: '',
      disabled: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 582,
        columnNumber: 37
      }
    }, "Image Type"), this.state.imageTypes.map(type => /*#__PURE__*/React.createElement(MenuItem, {
      value: type,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 584,
        columnNumber: 41
      }
    }, type))))))));
  }
  setEntityFields(nameSpace, entityId) {
    this.state.nameSpace = nameSpace;
    this.state.inputId = entityId;
  }
}
export default withStyles(styles)(withRouter(withCookies(Upload)));